import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { FormattedDateTime } from '@10xLabs/react-web/components/FormattedDateTime'
import { callStatusMessages } from 'features/Bookings/components/CallStatus/messages'
import { notificationChannelMessages } from 'features/Bookings/components/NotificationChannel/messages'
import { safeFormatMessage } from 'utils/intl'

export const SupportInteractions = ({ supportInteractions, showUser }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      {supportInteractions.length > 0 ? (
        <div>
          <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{supportInteractions.length}</StyledLink>
        </div>
      ) : (
        0
      )}

      {supportInteractions.length > 0 && isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="bookings.supportInteractions.title" defaultMessage="Support interactions" />
            </Heading.H5>
          </Modal.Header>

          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="dictionary.date" defaultMessage="Date" />
                    </Th>

                    {showUser && (
                      <Th>
                        <FormattedMessage id="dictionary.user" defaultMessage="User" />
                      </Th>
                    )}

                    <Th>
                      <FormattedMessage id="dictionary.notificationChannel" defaultMessage="Notification channel" />
                    </Th>

                    <Th>
                      <FormattedMessage id="dictionary.statusCall" defaultMessage="Status call" />
                    </Th>

                    <Th>
                      <FormattedMessage id="dictionary.notes" defaultMessage="Notes" />
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {supportInteractions.map((supportInteraction: TSFixMe, index: TSFixMe): TSFixMe => {
                    return (
                      <Tr key={index}>
                        <Td>
                          <FormattedDateTime intl={intl} date={supportInteraction.createdAt} />
                        </Td>

                        {showUser && <Td>{supportInteraction.user.username}</Td>}

                        <Td>
                          {supportInteraction.notificationChannel
                            ? safeFormatMessage({
                                intl,
                                messages: notificationChannelMessages,
                                key: supportInteraction.notificationChannel
                              })
                            : '-'}
                        </Td>

                        <Td>
                          {supportInteraction.callStatus
                            ? safeFormatMessage({
                                intl,
                                messages: callStatusMessages,
                                key: supportInteraction.callStatus
                              })
                            : '-'}
                        </Td>

                        <Td>{supportInteraction.notes ? supportInteraction.notes : '-'}</Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
